import { message } from "antd";
import axiosInstance from "../shared/axios";

const getPermissionsAll = async (params) => {
  try {
    const result = await axiosInstance.get("/client-prescription/viewAll", {
      params: {
        type: params?.type,
        startDate: params?.startDate,
        endDate: params?.endDate,
        name: params?.name,
        clientID: params?.clientID,
        pageNo: params?.pageNo,
        recordsPerPage: params?.recordsPerPage,
      },
    });
    if (result?.status === 200 && result?.data?.success) {
      return {
        data: result?.data?.data || [],
        total: result?.data?.totalRecords || 0,
      };
    } else {
      message.error("Error while loading medicines group");
      return { data: [], total: 0 };
    }
  } catch (error) {
    message.error(
      error?.response?.data?.message || "Error while loading medicines group",
    );
    return { data: [], total: 0 };
  }
};

const getPrescriptionDetail = async (id) => {
  try {
    let result = await axiosInstance?.get(`/client-prescription/edit/${id}`);
    if (result?.status === 200 && result?.data?.success) {
      return result?.data?.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
};

const deletePrescription = async (id) => {
  try {
    const result = await axiosInstance.delete(`/medicine-group/delete/${id}`);

    if (result?.status >= 200 && result?.status < 300) {
      return { success: true };
    } else {
      return { success: false };
    }
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to delete medicines group",
    };
  }
};

export const prescriptionapi = {
  getPermissionsAll,
  getPrescriptionDetail,
  deletePrescription,
};
